import type { FullCell } from "../contract/recommendation-context-types";

export const buildQuickStudyLaunch = ({
	cell,
	actualItemCount,
	estimatedDurationSeconds,
}: {
	cell: FullCell;
	actualItemCount: number;
	estimatedDurationSeconds: number;
}) => ({
	numItems: actualItemCount,
	minutes: Math.ceil(estimatedDurationSeconds / 60),
	distribution: cell.source.launch.distribution,
	tags: cell.source.launch.tagGroups,
});
